import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.activateTabFromAnchor()
  }

  selectTab(event) {
    event.preventDefault()
    this.activateTab(event.currentTarget)
  }

  activateTabFromAnchor() {
    const url = window.location.href
    if (url.indexOf("#") > 0) {
      const anchor = url.substring(url.indexOf("#") + 1)
      const el = document.querySelector(`[href="#${anchor}"]`)
      if (el) {
        this.activateTab(el)
      }
    }
  }

  activateTab(element) {
    const target = element.getAttribute("data-bs-target") || element.getAttribute("href")
    if (target) {
      const targetPane = document.querySelector(target)
      if (targetPane) {
        // Remove active class from all tabs and panes in the same tab container
        const tabContainer = element.closest('[data-controller="tabs"]')
        if (tabContainer) {
          tabContainer.querySelectorAll('[data-bs-toggle="tab"], [role="tab"]').forEach((tab) => {
            tab.classList.remove("active")
          })
          tabContainer.querySelectorAll('[role="tabpanel"]').forEach((pane) => {
            pane.classList.remove("active", "show")
          })
        }

        // Add active class to clicked tab and its pane
        element.classList.add("active")
        targetPane.classList.add("active", "show")
      }
    }
  }
}
